import { LinkedCardType } from '@superthread-com/api';

export default {
  computed: {
    cardRelationStatus() {
      return {
        blocks: {
          icon: 'black-flag',
          color: '#F97066',
          label: this.translate('blocking'),
        },
        blocked_by: {
          icon: 'flag',
          color: '#FDB022',
          label: this.translate('blocked'),
        },
        related: {
          icon: 'repeat',
          color: '#667085',
          label: this.translate('related'),
        },
        duplicates: {
          icon: 'copy',
          color: '#667085',
          label: this.translate('duplicate'),
        },
      };
    },
    cardRelationLabels() {
      return {
        [LinkedCardType.Blocks]: this.translate('blockedBy'),
        [LinkedCardType.BlockedBy]: this.translate('blocking'),
        [LinkedCardType.Related]: this.translate('relatedTo'),
        [LinkedCardType.Duplicates]: this.translate('duplicateOf'),
      };
    },
  },
};
